/* global __CLIENT__ */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';/*
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faThumbsUp, faEye, faThumbsDown,
} from '@fortawesome/free-regular-svg-icons'; */
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import Spinner from '../../../common/Spinner/Spinner';
import HeaderTags from '../../../common/headerTags/HeaderTags';

export default class JournalistSinglePage extends PureComponent {
    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        if (this.props.journalistsData.length === 0) {
            // no journalist data yet, get it
            this.props.getJournalistsData();
        } else {
            const journalist = this.props.journalistsData.find((currentJournalist) => currentJournalist.slug === this.props.slug);

            if (journalist && journalist.news && journalist.news.length === 0) {
                // no news yet, get some (if the journalist was found)
                // note, as this is only run on client, there won't be a problem as the journalist data will be present from the all jornalist page (or some other jornalist) or because it was prefetched on the server
                this.props.getJournalistNews(journalist.id);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.journalistsData.length !== this.props.journalistsData.length) {
            const journalist = this.props.journalistsData.find((currentJournalist) => currentJournalist.slug === this.props.slug);

            if (journalist && journalist.news && journalist.news.length === 0) {
                // no news yet, get some (if the journalist was found)
                this.props.getJournalistNews(journalist.id);
            }
        }
    }

    _getNews = (id, init) => {
        this.props.getJournalistNews(id, undefined, init);
    }

    _mapNews = (news, isLoadingNews) => {
        if (news.length === 0) {
            // no news. might still be loading, or, if not more loading, there are none for this journalist
            return isLoadingNews ?
                <div className="centerText">
                    <Spinner />
                </div>
                :
                <div className="centerText">Não há notícias</div>;
        }

        // show news
        return news.map((newsItem) => (
            <div key={`news-${newsItem.id}`} className="slot">
                <div className="newsContent">
                    <div className="newsTitle">
                        <Button className="toNews" title="Leia mais sobre esta notícia" to={`/noticias/${newsItem.slug}`}>
                            {newsItem.title}
                        </Button>
                    </div>
                    <div className="newsData">
                        <div className="newsDate mrNewsData">
                            <time dateTime={newsItem.date}>
                                {new Date(newsItem.date).toLocaleDateString()}
                            </time>
                        </div>
                        {/* <div className="mrNewsData"><FontAwesomeIcon icon={faThumbsUp} width="16" /> {newsItem.like}</div>
                            <div className="mrNewsData"><FontAwesomeIcon icon={faThumbsDown} width="16" /> {newsItem.dislike}</div>
                            <div className="mrNewsData"><FontAwesomeIcon icon={faEye} width="16" /> {newsItem.reads + newsItem.views}</div> */}
                    </div>
                </div>
                <Button className="toNews" title="Leia mais sobre esta notícia" to={`/noticias/${newsItem.slug}`}>
                    <div>
                        <img src="/keyboard-right-arrow-button.svg" alt="Ícone seta para a direita" />
                    </div>
                </Button>
            </div>
        ));
    }


    render() {
        if (this.props.journalistsData.length === 0 && this.props.isLoadingData) {
            // not loaded yet
            return <Spinner />;
        }

        const journalist = this.props.journalistsData.find((currentJournalist) => currentJournalist.slug === this.props.slug);

        if (!journalist) {
            // there was no journalist found for the given slug
            return <ErrorPage
                errorNumber={404}
                backLink="/jornalistas"
                title="NÃO ACHAMOS ESSE JORNALISTA :("
                message="Verifique se o link foi digitado corretamente."
                buttonText="Clique aqui para ver os nossos jornalistas"
            />;
        }

        const headerTags =
        {
            title: `Jornalista - ${journalist.name}`, // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
            meta:
            {
                description: `Saiba mais sobre ${journalist.name}`,
                keywords: `${journalist.name}, noticias, jornalista, imprensa, cotidiano, economia, musica, mundo, politica, saude, tecnologia`,
                'og:title': `Jornalista - ${journalist.name}`,
                'og:description': `Saiba mais sobre ${journalist.name}`,
                'og:image': `https://a1media.antena1.com.br/image/journalists/300x300/${journalist.imageFile}`,
                'og:image:width': 300,
                'og:image:height': 300,
            },
        };
        let imageSize = '200x200';

        if (__CLIENT__ && window.screen.width > 768) {
            imageSize = '300x300';
        }

        const image = `https://a1media.antena1.com.br/image/journalists/${imageSize}/${journalist.imageFile}`;
        const news = journalist.news;
        const isLoadingNews = this.props.isLoadingNews;
        let btnText = 'Mais notícias';
        let inactiveButton = '';

        if (isLoadingNews) {
            btnText = ['Carregando ', <span key="dot" className="loadingDots" />];

            inactiveButton = 'buttonDisabled';
        }

        return (
            <div className="journalistSingleContainer">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <Button className="backToPage" title="Veja mais jornalistas." to="/jornalistas">
                    <img src="/keyboard-right-arrow-button.svg" alt="Ícone seta para a esquerda" />
                    {' '}
                    Veja todos os jornalistas.
                </Button>
                <div className="journalistSingleImage">
                    <img src={image} alt={`Imagem de ${journalist.name}`} />
                </div>
                <div className="journalistSingleExcerpt">
                    <h3 className="journalistSingleName">
                        {journalist.name}
                    </h3>
                    {!journalist.isActive &&
                    <p className="exJournalist">(Não faz mais parte da Antena 1)</p>}
                    <p>
                        {journalist.description}
                    </p>
                </div>
                <div className="newsListTitle">
                    <h5>Notícias</h5>
                    <div className="newsList">
                        {this._mapNews(news, isLoadingNews)}
                    </div>
                </div>
                <Button className={`loadMoreNews ${inactiveButton}`} title="Carregar mais notícias." onClick={() => this._getNews(journalist.id, news.length)}>
                    {btnText}
                </Button>
            </div>
        );
    }
}

JournalistSinglePage.propTypes = exact({
    slug: PropTypes.string.isRequired,
    journalistsData: PropTypes.object,
    getJournalistsData: PropTypes.func.isRequired,
    getJournalistNews: PropTypes.func.isRequired,
    isLoadingNews: PropTypes.bool.isRequired,
    isLoadingData: PropTypes.bool,
});
